import React, { useContext, useRef, useState } from 'react'
import Modal from 'react-bootstrap/Modal'

type ModalContextProviderProps = {
  title: string
  body: JSX.Element
  children: JSX.Element
  buttonOkDisabled: boolean | undefined
  buttonCancel: string
  buttonOk: string
  buttonOkWarn: boolean
  buttonOkValidation?: (() => boolean) | undefined
}

const ModalContext = React.createContext({})

const ModalContextProvider = ({
  title,
  body,
  children,
  buttonCancel,
  buttonOk,
  buttonOkWarn,
  buttonOkValidation,
  buttonOkDisabled,
}: ModalContextProviderProps) => {
  const [showModal, setShowModal] = useState(false)
  const resolver: any = useRef()

  const handleShow = () => {
    setShowModal(true)

    return new Promise(function (resolve) {
      resolver.current = resolve
    })
  }

  const handleOk = () => {
    if (buttonOkValidation && !buttonOkValidation()) return
    resolver.current && resolver.current(true)
    setShowModal(false)
  }

  const handleCancel = () => {
    resolver.current && resolver.current(false)
    setShowModal(false)
  }

  return (
    <ModalContext.Provider value={{ openModal: handleShow }}>
      {children}

      <Modal
        show={showModal}
        onHide={handleCancel}
        backdrop="static"
        keyboard={false}
      >
        <div className="container responsive-font">
          <Modal.Header className="responsive-button" closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>{body}</Modal.Body>

          <Modal.Footer>
            <button
              className="responsive-button btn btn-secondary"
              onClick={handleCancel}
            >
              {buttonCancel}
            </button>
            <button
              disabled={buttonOkDisabled}
              className={
                buttonOkWarn
                  ? 'responsive-button btn btn-danger'
                  : 'responsive-button btn btn-primary'
              }
              onClick={handleOk}
            >
              {buttonOk}
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    </ModalContext.Provider>
  )
}

export const useModalContext = () => useContext(ModalContext)
export default ModalContextProvider
